export default __webpack_public_path__ + "static/media/youtube.abb4b441.png";